import makeRequest from './common/helpers/makeRequest';
import { PayloadType } from './common/types/general';
import type { EncryptedItem } from './common/types/items';

const loadItems = async (payloadType: PayloadType) => {
  return await makeRequest<{ items: EncryptedItem[] } | null>(`/items/${payloadType}`, 'GET');
};

const loadItemsInDateRange = async (payloadType: string) => {
  const dateFrom = '2022-12-01';
  const dateTo = '2022-12-31';
  return await makeRequest<{ items: EncryptedItem[] } | null>(
    `/items/${payloadType}/date/${dateFrom}/${dateTo}`,
    'GET'
  );
};

const loadItemById = async (id: string) => {
  return await makeRequest<{ item: EncryptedItem | null }>(`/item/${id}`, 'GET');
};

const addItem = async (id: string, payload: string, payloadType: string) => {
  return await makeRequest<EncryptedItem | undefined>('/item', 'POST', JSON.stringify({ id, payload, payloadType }));
};

const editItem = async (id: string, payload: string) => {
  return await makeRequest<boolean>(`/item/${id}`, 'POST', payload);
};

const deleteItem = async (id: string) => {
  return await makeRequest<boolean>(`/item/${id}`, 'DELETE');
};

const api = {
  loadItems,
  loadItemsInDateRange,
  loadItemById,
  addItem,
  editItem,
  deleteItem,
};

export default api;
